import { RoomHelperAction } from '../constants/enums'
import {
    FCTYPE_CHANOP,
    FCTYPE_QUIETCHAN,
    FCTYPE_ROOMDATA,
    FCTYPE_SETWELCOME,
    FCTYPE_ZBAN,
} from '../mfcLogic/mfcConstants'
import { roomHelperAction } from './workerActions'

export function roomHelperSendBan(
    modelId: number,
    options: {
        username?: string
        sid?: number
        clearchat?: boolean
        unban?: boolean
    },
) {
    const data: Record<string, any> = {
        type: FCTYPE_ZBAN,
        model: modelId,
        op: options.unban ? 'unban' : 'ban',
    }
    if (options.username) data.username = options.username
    if (options.clearchat) data.clearchat = 1
    if (options.sid) data.sid = options.sid

    roomHelperAction(RoomHelperAction.SEND_COMMAND, {
        commandType: FCTYPE_ZBAN,
        modelId,
        data,
    })
}

export function roomHelperSendKick(
    modelId: number,
    chan: number,
    users: Array<string | number>,
) {
    const data = {
        type: FCTYPE_CHANOP,
        model: modelId,
        op: 'kick',
        chan,
        users,
    }

    roomHelperAction(RoomHelperAction.SEND_COMMAND, {
        commandType: FCTYPE_CHANOP,
        modelId,
        data,
    })
}

export function roomHelperSendMuteUser(
    modelId: number,
    options: {
        username?: string
        sid?: number
        clearchat?: boolean
        unmute?: boolean
    },
) {
    const data: Record<string, any> = {
        type: FCTYPE_ZBAN,
        model: modelId,
        op: options.unmute ? 'unmute' : 'mute',
        ztype: 'm',
    }
    if (options.username) data.username = options.username
    if (options.clearchat) data.clearchat = 1
    if (options.sid) data.sid = options.sid

    roomHelperAction(RoomHelperAction.SEND_COMMAND, {
        commandType: FCTYPE_ZBAN,
        modelId,
        data,
    })
}

export function roomHelperSendMuteLevel(
    modelId: number,
    optmask: number,
    optvalues: number,
) {
    const data = {
        type: FCTYPE_QUIETCHAN,
        model: modelId,
        optmask,
        optvalues,
    }

    roomHelperAction(RoomHelperAction.SEND_COMMAND, {
        commandType: FCTYPE_QUIETCHAN,
        modelId,
        data,
    })
}

export function roomHelperSendTopic(modelId: number, topic: string) {
    const data = {
        type: FCTYPE_SETWELCOME,
        model: modelId,
        topic,
    }

    roomHelperAction(RoomHelperAction.SEND_COMMAND, {
        commandType: FCTYPE_SETWELCOME,
        modelId,
        data,
    })
}

export function roomHelperSendCountdown(
    modelId: number,
    payload: Record<string, any>,
) {
    roomHelperAction(RoomHelperAction.SEND_COMMAND, {
        commandType: FCTYPE_ROOMDATA,
        modelId,
        data: payload,
    })
}
